import { apiRTK } from "../apiRTK";
import { PYCEILING_BASE_URL } from "../DesignTab/designRTK";
import { IAdjustedCeiling, IHimlingSpace, IMLResult } from "../types/types";

export const pyceilingRTK = apiRTK.injectEndpoints({
  endpoints: (builder) => ({
    predictStandardSpace: builder.query<
      IMLResult[],
      {
        himlingSpace: IHimlingSpace | undefined;
        standardSpaceRoomNr: string;
      }
    >({
      query: (input) => ({
        url: `${PYCEILING_BASE_URL}/predict-standard-space`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          space: input.himlingSpace,
          standardSpaceId: input.standardSpaceRoomNr,
        },
      }),
      providesTags: ["PredictSpace"],
    }),
    predictStandardSpaceWithAdjustedCeiling: builder.query<
      IMLResult[],
      {
        himlingSpace: IHimlingSpace | undefined;
        standardSpaceRoomNr: string;
        adjustedCeiling?: IAdjustedCeiling;
      }
    >({
      query: (input) => ({
        url: `${PYCEILING_BASE_URL}/predict-standard-space`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          space: input.himlingSpace,
          standardSpaceId: input.standardSpaceRoomNr,
          adjustedCeiling: input.adjustedCeiling,
        },
      }),
      providesTags: ["PredictSpace"],
    }),
    pingPyCeiling: builder.query<string, void>({
      query: () => ({
        url: `${PYCEILING_BASE_URL}/ping`,
        method: "GET",
      }),
    }),
  }),
});

export const { usePredictStandardSpaceQuery, usePingPyCeilingQuery } = pyceilingRTK;
